import React from 'react';
import { createPortal } from 'react-dom';

const OFFSET_X = 2;
const OFFSET_Y = -14;
export default ({ anchor, children }) => {
  const { left, top, width, height } = anchor.getBoundingClientRect();
  return createPortal(
    <div
      className="tooltip bs-tooltip-right show"
      style={{
        transform: `translate(${left + width + OFFSET_X}px, ${top +
          height / 2 +
          OFFSET_Y}px)`,
      }}
    >
      <div className="arrow mt-2" />
      <div className="tooltip-inner text-left">{children}</div>
    </div>,
    document.getElementById('tooltip'),
  );
};
